import { Component, OnInit } from '@angular/core';
import { CompanyInfoStateService } from '../../modules/contact/services/company-info-state.service';

@Component({
  selector: 'app-agb',
  templateUrl: './app-agb.component.html',
  styleUrls: ['./app-agb.component.css']
})
export class AppAgbComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
  }

}
